import { Component, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';


/**
 * Campo de checkbox
 */
@Component({
    selector: 'app-checkbox',
    template: `
      <div [formGroup]="form">
          <div class="form-check form-check">
          <label class="form-check-label">
             <input class="form-control"
             [formControlName]="field.name"
              [attr.disabled]="field.disabled" [id]="field.name"
              [name]="field.name" class="form-check-input"
              type="checkbox" id="inlineCheckbox1" [checked]="field.value"/>
             {{field.label}}</label>
          </div>
      </div>
    `,
    standalone: false
})
export class CheckBoxComponent {
  /**
   * Campo del formulario
   */
  @Input() field: any = {};
  /**
   * Formulario
   */
  @Input() form!: UntypedFormGroup;
  /**
   * Indica si es valido
   */
  get isValid(): any {
    return this.form.controls[this.field.name].valid;
  }
  /**
   * Indica si esta sucio
   */
  get isDirty(): any {
    return this.form.controls[this.field.name].dirty;
  }
  /**
   * Indica si fue tocado
   */
  get isTouched(): any {
    return this.form.controls[this.field.name].touched;
  }

  /**
   * Constructor
   */
  constructor() {
  }
}
